import { render, staticRenderFns } from "./TableDataServerSide.vue?vue&type=template&id=ffe5364a&"
import script from "./TableDataServerSide.vue?vue&type=script&lang=js&"
export * from "./TableDataServerSide.vue?vue&type=script&lang=js&"
import style0 from "./TableDataServerSide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports